
import { Collapse, Layout, Menu, MenuProps, Modal,Button, Avatar, Divider } from 'antd';

import { Link, Outlet } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import  {AxiosError} from "axios";
import {
  UserOutlined,
  SnippetsOutlined,
  FileAddOutlined,
  OrderedListOutlined,
  SmileTwoTone,
  HomeOutlined,
  LogoutOutlined,
  BarChartOutlined,
  UnorderedListOutlined
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
const { Sider, Header, Content, Footer } = Layout;
// import styles from './Layout.module.scss';
import { useAuth } from 'hooks';
import logo from 'assets/images/LogoSimHOR.png';
import smallLogo from 'assets/images/allin1logoNoText.png';
import {User,getCurrUserDetailByUserId} from 'services/UserServices';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { jwtDecode } from "jwt-decode";
import ShopFrontHeader from 'modules/shop-front/shop-front-component/ShopFrontHeader';
import DesktopHeader from './DesktopHeader';
import ShopFrontHeaderSticky from 'modules/shop-front/shop-front-component/ShopFrontHeaderSticky';
import SmallHeaderSticky from 'modules/shop-front/shop-front-component/SmallHeaderSticky';

const NOTICE_TIME = 900
type MenuItem = Required<MenuProps>['items'][number];
function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
  } as MenuItem;
}



const FullLayoutWrapper: React.FC = () => {
  return (
    
      <Content className=' hedvig-letters-sans-regular flex flex-col gap-4 '>
        <ShopFrontHeaderSticky></ShopFrontHeaderSticky>
        <SmallHeaderSticky></SmallHeaderSticky>
        <Content className='mt-32 sm:mt-40 px-1 lg:px-5 mb-10'>
          <Outlet/>
        </Content>
        
      </Content>
  );
};

export default FullLayoutWrapper; 
